import { useState } from 'react';
import { useCreateCustomerContact } from '../../../../hooks/useCreateCustomerContact';
import {
  CustContactCharacteristicType,
  CustContactCharacteristicValue,
  CustContactClass,
  CustContactType,
} from '../../../../hooks/useSSMStopService';
import { useErrorNotification } from '../common/error-notification';

export function useMyPowerIsOn() {
  const { submit } = useCreateCustomerContact();
  const { setErrorNotification } = useErrorNotification();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isSuccessful, setIsSuccessful] = useState<boolean>(false);

  const submitPowerIsOn = (
    accountNumber?: string | undefined,
    encryptedPersonId?: string | undefined,
  ) => {
    setIsLoading(true);
    const datetime = new Date().toLocaleString('en-US', {
      timeZone: 'America/Los_Angeles',
    });

    const payload = {
      accountNumber: accountNumber ?? '',
      longDescription: `The customer with account number ${accountNumber} has informed at ${datetime} that their power is on.`,
      encryptedPersonId,
      contactClass: CustContactClass.OUT,
      contactType: CustContactType.REPOUT,
      characteristics: [
        {
          type: CustContactCharacteristicType.CMCHNNL,
          value: CustContactCharacteristicValue.CSWEB,
          action: '',
        },
      ],
      shouldPrintLetter: false,
    };

    submit(payload)
      .then(response => {
        if (!response?.data?.createWebCustomerContact) {
          setErrorNotification();
        }
        if (response?.data?.createWebCustomerContact) {
          setIsSuccessful(true);
        }
      })
      .catch(() => {
        setErrorNotification();
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return {
    submitPowerIsOn,
    isSuccessful,
    isLoading,
  };
}
